import Titulo from './img-video/TITULO.png';
import './ContentCafeRural.css'
import talleres from "./talleres.json"
import react from 'react';
import { useEffect } from 'react';

export const Calendario = () => {

    let hora = '10:00'

	return (
		<>
			<section id="calendario" className="calendario">
                <div className='titulo-img'>
                    <img src={Titulo}></img>
                </div>
                <div class="calendar-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Localidad</th>
                                <th>Dirección</th>
                                <th>Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            talleres.slice(0, 10).map((taller, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="numero">{taller.fecha.dia || ""}</div>
                                        <div className="mes">{taller.fecha.mes || ""}</div>
                                    </td>
                                    <td>
                                        {typeof taller.lugar === "object" && taller.lugar.localidad ? (
                                            <>
                                                <div className="lugar">{taller.lugar.localidad}</div>
                                                <div className="third-column mes">{taller.lugar.Provincia}</div>
                                            </>
                                        ) : (
                                            <div className="localidad">Pendientes de confirmar</div>
                                        )}
                                    </td>
                                    <td className="third-column mes">
                                        {typeof taller.direccion === "object" && taller.direccion.lugar ? (
                                            <>
                                                <div>{taller.direccion.lugar}</div>
                                                <div>{taller.direccion.direccion}</div>
                                            </>
                                        ) : (
                                            <div className="localidad">Pendientes de confirmar</div>
                                        )}
                                    </td>
                                    <td>
                                        {
                                            taller.lugar.localidad === 'Hoyos' ? (
                                                <div className="lugar">10:30</div>
                                            ):<div className="lugar">{hora}</div>
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>

                    <table>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Lugar</th>
                                <th>Dirección</th>
                                <th>Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            talleres.slice(10, 19).map((taller, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="numero">{taller.fecha.dia || ""}</div>
                                        <div className="mes">{taller.fecha.mes || ""}</div>
                                    </td>
                                    <td>
                                        {typeof taller.lugar === "object" && taller.lugar.localidad ? (
                                            <>
                                                <div className="lugar">{taller.lugar.localidad}</div>
                                                <div className="third-column">{taller.lugar.Provincia}</div>
                                            </>
                                        ) : (
                                            <div>Pendientes de confirmar</div>
                                        )}
                                    </td>
                                    <td className="third-column">
                                        {typeof taller.direccion === "object" && taller.direccion.lugar ? (
                                            <>
                                                <div>{taller.direccion.lugar}</div>
                                                <div>{taller.direccion.direccion}</div>
                                            </>
                                        ) : (
                                            <div>Pendientes de confirmar</div>
                                        )}
                                    </td>
                                    <td>
                                        <div className='lugar'>{hora}</div>
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </section>
		</>
	);
};
